const selectors = {
  dragscroll: '.dragscroll',
};

// Prevent click on drag event
const clickFix = () => {
  const dragscroll = document.querySelectorAll(selectors.dragscroll);

  dragscroll.forEach(el => {
    let clickTime;

    el.addEventListener('mousedown', () => {
      clickTime = new Date();
    });

    el.addEventListener('click', (event) => {
      if (new Date() - clickTime >= 200) {
        event.preventDefault();
      }
    });
  });
};

export default clickFix;
